import React, { useState } from 'react';
import SlackLogin from 'react-slack-login';
import './index.css';
import {API_ROOT} from '../../constants/api';

function Signup() {
  // Construct absolute URL for redirect_uri (Slack requires absolute URLs)
  // Must match what backend expects in oauth/views.py
  let redirect_uri = '';
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) {
    redirect_uri = "http://localhost:8000/django/oauth/slack_auth";
  } else {
    redirect_uri = "https://gallery.dailybruin.com/django/oauth/slack_auth";
  }
  // URL encode for use in query string
  const encoded_redirect_uri = encodeURIComponent(redirect_uri);
  
  return (
    <div className="signup-container">
      {/* <a href={url}>Do things.</a> */}
      <h1 className="signup-title"> Gallery Maker </h1>
      <div className="slack-link-container">
        <a href={`https://slack.com/oauth/v2/authorize?user_scope=identity.basic&client_id=4526132454.1973927489168&redirect_uri=${encoded_redirect_uri}&state=${encoded_redirect_uri}`}>
          <img
            alt="Sign in with Slack"
            height="40"
            width="172"
            src="https://platform.slack-edge.com/img/sign_in_with_slack.png"
            srcset="https://platform.slack-edge.com/img/sign_in_with_slack.png 1x, https://platform.slack-edge.com/img/sign_in_with_slack@2x.png 2x"
          />
        </a>
        {/* {loggedIn ? <div>Success</div> : <div>Failure</div>} */}
      </div>
    </div>
  );
}

export default Signup;
